/* Favoritten — quick-add til kurv fra produktkort.
   Én global listener (event delegation) — loades én gang via theme.liquid. */

/* Header-badge-opdatering: bruges af quick-add OG produktsidens ATC
   via eventet 'fav:cart:count' (detail = item_count). */
(function () {
  function updateBadge(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = Math.min(count, 99);
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }
  document.addEventListener('fav:cart:count', function (e) { updateBadge(e.detail); });
  window.FavCartBadge = updateBadge;

  /* Skjult aria-live-region til statusbeskeder (fejl ved quick-add m.m.) */
  window.FavAnnounce = function (msg) {
    var r = document.getElementById('fav-live-region');
    if (!r) {
      r = document.createElement('div');
      r.id = 'fav-live-region';
      r.setAttribute('role', 'status');
      r.setAttribute('aria-live', 'assertive');
      r.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      document.body.appendChild(r);
    }
    r.textContent = '';
    setTimeout(function () { r.textContent = msg; }, 50);
  };
})();

/* ── Lagerloft i kurven ──────────────────────────────────────────────
   Shopify accepterer flere styk end der er paa lager via /cart/add.js, men
   returnerer derefter NUL fragtrater — checkout doer uden forklaring.
   Verificeret: lager 9, kurv 10 => 0 rater; kurv 9 => 2 rater.
   Her rettes kurven ned til lageret saa snart den vises, uanset hvordan
   den er opstaaet (dobbelt add, gammel kurv-cookie, /cart/VARIANT-permalink). */
(function () {
  if (window._favStockCapInit) return;
  window._favStockCapInit = true;

  function fixOverstock() {
    var over = [];
    document.querySelectorAll('input[data-max-stock]').forEach(function (el) {
      var cap = parseInt(el.dataset.maxStock, 10);
      var qty = parseInt(el.value, 10);
      if (!isNaN(cap) && !isNaN(qty) && qty > cap) {
        over.push({ key: el.dataset.itemKey || el.dataset.quantityVariantId, cap: cap, qty: qty });
      }
    });
    if (!over.length) return;

    var o = over[0];
    if (!o.key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(o.key), quantity: o.cap })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var msg = o.cap === 0
          ? 'En vare i kurven er udsolgt og er fjernet.'
          : 'Vi har kun ' + o.cap + ' stk. på lager — antallet er rettet.';
        // Beskeden skal overleve reload, ellers rettes antallet tavst
        try { sessionStorage.setItem('fav-stock-msg', msg); } catch (e) {}
        if (window.FavCartBadge) window.FavCartBadge(cart.item_count);
        location.reload();
      })
      .catch(function () {});
  }

  /* Vis beskeden fra foer reload */
  function showPendingMsg() {
    var msg;
    try { msg = sessionStorage.getItem('fav-stock-msg'); } catch (e) { return; }
    if (!msg) return;
    try { sessionStorage.removeItem('fav-stock-msg'); } catch (e) {}
    if (window.FavAnnounce) window.FavAnnounce(msg);
    // Fast toast paa <body>: kurv-drawer og sektioner gen-renderes og ville
    // slette en notits indsat i dem. querySelector med kommaliste rammer
    // desuden foerste match i DOKUMENTraekkefoelge, ikke selector-raekkefoelge.
    var bar = document.createElement('div');
    bar.className = 'fav-stock-notice';
    bar.setAttribute('role', 'status');
    bar.textContent = msg;
    document.body.appendChild(bar);
    requestAnimationFrame(function () { bar.classList.add('is-in'); });
    setTimeout(function () { bar.classList.remove('is-in'); }, 6000);
    setTimeout(function () { bar.remove(); }, 6600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { showPendingMsg(); fixOverstock(); });
  } else {
    showPendingMsg();
    fixOverstock();
  }
  document.addEventListener('fav:cart:count', function () { setTimeout(fixOverstock, 300); });
})();
(function () {
    if (window._favQuickAddInit) return;
    window._favQuickAddInit = true;

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      // Prevent double-clicks
      if (btn.disabled) return;
      btn.disabled = true;

      const originalContent = btn.innerHTML;
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg><span class="pc__quick-add-text">Tilføjer...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        // /cart/add.js svarer 422 med { status, description } når varen ikke kan tilføjes
        if (!result.ok || result.data.status) {
          var msg = (result.data && (result.data.description || result.data.message)) || 'Varen kunne ikke tilføjes';
          window.FavAnnounce(msg);
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg><span class="pc__quick-add-text">Ikke tilføjet</span>';
          btn.style.background = '#b3261e';
          setTimeout(function () {
            btn.innerHTML = originalContent;
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
          return;
        }
        // Show success state
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span class="pc__quick-add-text">Tilføjet!</span>';
        btn.style.background = '#22c55e';

        // Open cart drawer — fetch both sections Dawn needs
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch('/cart.js').then(function (r) { return r.json(); })
            .then(function (cart) { window.FavCartBadge(cart.item_count); });
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents({ sections: data });
              }
              if (typeof cartDrawer.open === 'function') cartDrawer.open(btn);
            });
        } else {
          // Fallback: update count badge manually
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { window.FavCartBadge(cart.item_count); });
        }

        // Reset button after 2s
        setTimeout(function () {
          btn.innerHTML = originalContent;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        window.FavAnnounce('Varen kunne ikke tilføjes — prøv igen');
        btn.innerHTML = '<span class="pc__quick-add-text">Prøv igen</span>';
        setTimeout(function () {
          btn.innerHTML = originalContent;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      });
    });
  })();
